export const TOGGLE_TODOS = 'TOGGLE_TODOS'
export const IS_APPLICATION_LOADING = 'IS_APPLICATION_LOADING'
export const AUTH_USER_COMPLETE = 'AUTH_USER_COMPLETE'
export const USER_LOGOUT = 'USER_LOGOUT'
export const NETWORK_LOGOUT = 'NETWORK_LOGOUT'
export const LOAD_LOCAL_USER = 'LOAD_LOCAL_USER'
export const FETCH_SHIPPER_GROUPS = 'FETCH_SHIPPER_GROUPS'
export const CREATE_NEW_GROUP = 'CREATE_NEW_GROUP'
export const FETCH_SHIPPER_TARGETS = 'FETCH_SHIPPER_TARGETS'
export const FETCH_SHIPPER_PROFILES = 'FETCH_SHIPPER_PROFILES'
export const FETCH_SHIPPER_PLACES = 'FETCH_SHIPPER_PLACES'
export const FETCH_DATA_BY_CEP = 'FETCH_DATA_BY_CEP'
export const FETCH_SHIPPER_AVAILABLE_CERTIFICATES = 'FETCH_SHIPPER_AVAILABLE_CERTIFICATES'
export const FETCH_SHIPPER_AVAILABLE_PROPERTY = 'FETCH_SHIPPER_AVAILABLE_PROPERTY'
export const SHOW_USER_FEEDBACK = 'SHOW_USER_FEEDBACK'
export const STORE_CENTRIFUGE_INSTANCE = 'STORE_CENTRIFUGE_INSTANCE'
export const FETCH_USER_INFORMATION = 'FETCH_USER_INFORMATION'
export const POST_NEW_CENTRIFUGE_BID = 'POST_NEW_CENTRIFUGE_BID'
export const CENTRIFUGE_UPDATE_AUCTION_TIME = 'CENTRIFUGE_UPDATE_AUCTION_TIME'
export const STORE_KEYCLOAK_INSTANCE = 'STORE_KEYCLOAK_INSTANCE'
export const CENTRIFUGE_MULTIPLE_CHANNEL_SUBSCRIBED = 'CENTRIFUGE_MULTIPLE_CHANNEL_SUBSCRIBED'
export const CENTRIFUGE_CHANNEL_SUBSCRIBED = 'CENTRIFUGE_CHANNEL_SUBSCRIBED'
export const TICK_AUCTION_TIMER = 'TICK_AUCTION_TIMER'
export const TICK_AUCTION_TIMER2 = 'TICK_AUCTION_TIMER2'
export const FETCH_INCIDENT_CATEGORIES = 'FETCH_INCIDENT_CATEGORIES'
export const FETCH_ALL_SHIPPERS = 'FETCH_ALL_SHIPPERS'
export const CLEAR_SHIPPERS = 'CLEAR_SHIPPERS'
export const MAPBOX_DIRECTIONS_RESPONSE = 'MAPBOX_DIRECTIONS_RESPONSE'
export const IS_MARKET_LOADING = 'IS_MARKET_LOADING'
export const IS_DELIVERED_LOADING = 'IS_DELIVERED_LOADING'
export const IS_HIRED_LOADING = 'IS_HIRED_LOADING'
export const IS_IN_TRANSIT_LOADING = 'IS_IN_TRANSIT_LOADING'
export const SET_ERROR_TO_DISPLAY = 'SET_ERROR_TO_DISPLAY'

export const CLEAR_DOWNLOADED_REPORT = 'CLEAR_DOWNLOADED_REPORT'
export const REPORT_UPDATE_PROGRESS = 'REPORT_UPDATE_PROGRESS'
export const REPORT_HISTORY_FINISHED = 'REPORT_HISTORY_FINISHED'
export const REPORT_GENERATION_IS_LOADING = 'REPORT_GENERATION_IS_LOADING'

export const SET_COMMUNICATION_CONTENT = 'SET_COMMUNICATION_CONTENT'
export const COMMUNICATION_CONTENT_VISIBLE = 'COMMUNICATION_CONTENT_VISIBLE'

export const IS_MODAL_LOADING = 'IS_MODAL_LOADING'
